import React from "react";

const Java_Instanceof = () => {
  return (
    <div>
      <h1>Java Instanceof</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Instanceof in Java.</p>
    </div>
  );
};

export default Java_Instanceof;
